import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const EventBookingsBasicInfoComponent = ({
    selectEventBookings, handleInnerFormChange,libraryData,handleBasicFormChange,events,eventTickets,users
}: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className='grid md:grid-cols-3 lg:grid-cols-3 gap-4'>
                        <InputContainer
                             label="Event"
                             labelField="Name"
                             list={events}
                             onValueChange={(event: any) => {
                             handleBasicFormChange(
                             event.target.value,
                             'EventId',
                            )
                              }}
                              optionName="Choose Event"
                              type="select"
                               value={selectEventBookings?.EventId}
                               valueField="Id"
                                      />


                        <InputContainer
                             label="Event Ticket"
                             labelField="Name"
                             list={eventTickets}
                             onValueChange={(event: any) => {
                             handleBasicFormChange(
                             event.target.value,
                             'EventTicketId',
                            )
                              }}
                              optionName="Choose Event Ticket"
                              type="select"
                               value={selectEventBookings?.EventTicketId}
                               valueField="Id"
                                      />



                        <InputContainer
                                      label="User Profile"
                                      labelField="Email"
                                      list={users}
                                      onValueChange={(event: any, newValue: any) => {
                                        handleInnerFormChange(
                                          event.target.value,
                                          'UserProfileId'
                                        )
                                      }}
                                      optionName='Choose UserProfile'
                                      type="select"
                                      value={selectEventBookings?.UserProfileId}
                                      valueField="Id"
                                  />

                        <InputContainer
                            label="Quantity"
                            labelField="Quantity"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Quantity'
                                );
                            }}
                            type="number"
                            value={selectEventBookings?.Quantity}
                            />

                        <InputContainer
                            label="Total Amount"
                            labelField="TotalAmount"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'TotalAmount'
                                );
                            }}
                            type="number"
                            value={selectEventBookings?.TotalAmount}
                            />

                        <InputContainer
                            label="Currency"
                            labelField="Currency"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Currency'
                                );
                            }}
                            type="text"
                            value={selectEventBookings?.Currency}
                            />


                        <InputContainer
                             label="Booking Status"
                             labelField="Text"
                             list={libraryData.result.EventBookingStatus}
                             onValueChange={(event: any) => {
                             handleBasicFormChange(
                             event.target.value,
                             'BookingStatus',
                            )
                              }}
                              optionName="Choose Booking Status"
                              type="select"
                               value={selectEventBookings?.BookingStatus}
                               valueField="Value"
                                      />

                        <InputContainer
                             label="CheckIn Status"
                             labelField="Text"
                             list={libraryData.result.EventCheckInStatus}
                             onValueChange={(event: any) => {
                             handleBasicFormChange(
                             event.target.value,
                             'CheckInStatus',
                            )
                              }}
                              optionName="Choose CheckIn Status"
                              type="select"
                               value={selectEventBookings?.CheckInStatus}
                               valueField="Value"
                                      />

                        <InputContainer
                            label="Qr Code"
                            labelField="QrCode"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'QrCode'
                                );
                            }}
                            type="text"
                            value={selectEventBookings?.QrCode}
                            />

                        <InputContainer
                            label="Booking Date"
                            labelField="BookingDate"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'BookingDate'
                                );
                            }}
                            type="date"
                            value={selectEventBookings?.BookingDate}
                            />


                        <InputContainer
                            label="Active"
                            labelField="IsActive"
                            onValueChange={(event: any, newValue: any) => {
                                handleBasicFormChange(
                                    event,
                                    'IsActive',
                                    selectEventBookings?.BasicInfo
                                  )
                                }}
                            type="checkbox"
                            value={selectEventBookings?.IsActive}
                            />

                       
                        
                    </div>
                }
                expandedPanel="BasicInfo"
                headerTitle="Basic Info"
            />
        </>
    )
}

export default EventBookingsBasicInfoComponent;
